export default __webpack_public_path__ + "static/media/astro_pointing_up.4f81f465.png";